import listActions from 'src/modules/solicitud/list/solicitudListActions';
import SolicitudService from 'src/modules/solicitud/solicitudService';
import Errors from 'src/modules/shared/error/errors';
import { i18n } from 'src/i18n';
import { getHistory } from 'src/modules/history';
import Message from 'src/view/shared/message';

const prefix = 'SOLICITUD_DESTROY';

const solicitudDestroyActions = {
  DESTROY_STARTED: `${prefix}_DESTROY_STARTED`,
  DESTROY_SUCCESS: `${prefix}_DESTROY_SUCCESS`,
  DESTROY_ERROR: `${prefix}_DESTROY_ERROR`,

  DESTROY_ALL_STARTED: `${prefix}_DESTROY_ALL_STARTED`,
  DESTROY_ALL_SUCCESS: `${prefix}_DESTROY_ALL_SUCCESS`,
  DESTROY_ALL_ERROR: `${prefix}_DESTROY_ALL_ERROR`,

  doDestroy: (id) => async (dispatch) => {
    try {
      dispatch({
        type: solicitudDestroyActions.DESTROY_STARTED,
      });

      await SolicitudService.destroyAll([id]);

      dispatch({
        type: solicitudDestroyActions.DESTROY_SUCCESS,
      });

      Message.success(
        i18n('entities.solicitud.destroy.success'),
      );

      dispatch(listActions.doFetchCurrentFilter());

      getHistory().push('/solicitud');
    } catch (error) {
      Errors.handle(error);

      dispatch(listActions.doFetchCurrentFilter());

      dispatch({
        type: solicitudDestroyActions.DESTROY_ERROR,
      });
    }
  },

  doDestroyAll: (ids) => async (dispatch) => {
    try {
      dispatch({
        type: solicitudDestroyActions.DESTROY_ALL_STARTED,
      });

      await SolicitudService.destroyAll(ids);

      dispatch({
        type: solicitudDestroyActions.DESTROY_ALL_SUCCESS,
      });

      if (listActions) {
        dispatch(listActions.doClearAllSelected());
        dispatch(listActions.doFetchCurrentFilter());
      }

      Message.success(
        i18n('entities.solicitud.destroyAll.success'),
      );

      getHistory().push('/solicitud');
    } catch (error) {
      Errors.handle(error);

      dispatch(listActions.doFetchCurrentFilter());

      dispatch({
        type: solicitudDestroyActions.DESTROY_ALL_ERROR,
      });
    }
  },
};

export default solicitudDestroyActions;
